<template>
  <div class="board-view" :class="{ trans: pagination && false }">
    <block v-if="title" class="title">
      <row>
        <column :xs="hasButton ? 6 : 12" :sm="hasButton ? 9 : 12">
          <h2>
            {{ title }}
          </h2>
          <div>
            {{ sub }}
          </div>
        </column>
        <column v-if="hasButton" :xs="6" :sm="3">
          <slot name="button"/>
        </column>
      </row>
      <pagination-filter v-if="pagination"
        :pagination="pagination"
        @update:filterString="setFilterString"
        @update:sortIndex="setSort"/>
    </block>
    <slot/>
    <pagination-nav
      v-if="pagination"
      :pagination="pagination"
      :total="total"
      @change="setPage"/>
  </div>
</template>

<script>
import Pagination from '../../mixins/Pagination'
import { actions } from '../../utils'

export default {
  mixins: [Pagination],
  props: ['pagination', 'title', 'sub', 'total'],
  computed: {
    hasButton() {
      return this.$slots.button
    },
  },
  methods: {
    setSort(sortIndex) {
      this.PATCH_PAGINATION({
        pagination: this.pagination,
        sortIndex,
        page: 0,
      })
    },
    setFilterString(filterString) {
      this.PATCH_PAGINATION({
        pagination: this.pagination,
        page: 0,
        filter: filterString,
      })
    },
    setPage(page) {
      this.PATCH_PAGINATION({
        pagination: this.pagination,
        page,
      })
    },
    ...actions(
      'PATCH_PAGINATION',
    ),
  },
}
</script>

<style lang="scss">
@import '~style/variables';

.board-view {
  > .title {
    background: #fff;
    border-bottom: 1px solid $c-border;
    border-radius: 0;
    box-shadow: none;
    margin-bottom: 0;
    padding: 1rem;
    h2 {
      line-height: 2.5rem;
    }
    .btn span.add {
      display: none;
    }
    @media screen and (min-width: $res-md) {
      padding: 2rem 2rem 1.5rem;
      .btn span.add {
        display: inline-block;
      }
    }
  }
  > .form-sect {
    // background: #fff;
    box-shadow: $s-md;
    padding: 0.5rem 0;
  }
  h3, h4 {
    color: $c-dark;
    font-weight: $medium;
    margin-bottom: 0.5rem;
  }
  > .list, .pagination-filter {
    border-top: 1px solid $c-border;
    margin-top: 1rem;
    padding-top: 1rem;
    @media screen and (min-width: $res-md) {
      padding-top: 1.5rem;
    }
  }
  &.trans {
    > .title {
      background: transparent;
      color: #fff;
      input {
        color: $c-text-mid;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/BoardView.vue